type permissionsUserType = 'officer' | 'admin';

export const permissionsKeys = {
  page: 'micro-sites.transparency-page.page-block',
  pageBlockFind: 'micro-sites.transparency-page.page-block.find',
  pageBlockCreateDefault: 'micro-sites.transparency-page.page-block.createDefault',
  pageBlockUpdate: 'micro-sites.transparency-page.page-block.update',
  pageBlockPreview: 'micro-sites.transparency-page.page-block.preview',
  pageBlockUpdateInactivate: 'micro-sites.transparency-page.inactivate.page-block.update',
  pageBlockUpdateActive: 'micro-sites.transparency-page.active.page-block.update',
  pageBlockRemove: 'micro-sites.transparency-page.page-block.remove',
};
